var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-plusplus */
import { useFetch } from '@hn-front/utils';
import { parseISO } from 'date-fns';
var headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
};
export var createMarathon = function (dto) {
    return fetch('/api/v2/supervizors/marathons', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(dto),
    }).then(function (res) { return res.json(); });
};
export var transformMarathonStatus = function (value) {
    switch (value) {
        case 'completed':
            return 'completed';
        case 'scheduled':
            return 'scheduled';
        case 'current':
            return 'active';
        default:
            return 'canceled';
    }
};
export var getMarathons = function (schoolId) {
    return fetch("/api/v2/supervizors/marathons?filter[school_id]=" + schoolId, {
        headers: headers,
    })
        .then(function (res) { return res.json(); })
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .then(function (data) {
        return data.map(function (d) {
            return ({
                id: d.id,
                grades: d.gradeValues,
                author: d.author.fullName,
                type: transformMarathonStatus(d.status),
                startDate: d.startAt,
                endDate: d.endAt,
            });
        });
    });
};
export var cancelMarathon = function (id) {
    return fetch("/api/v2/supervizors/marathons/" + id + "/cancel", {
        method: 'POST',
        headers: headers,
    }).then(function (res) { return res.text(); });
};
export var editMarathon = function (_a) {
    var id = _a.id, gradeValues = _a.gradeValues;
    return fetch("/api/v2/supervizors/marathons/" + id, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify({ gradeValues: gradeValues }),
    }).then(function (res) { return res.json(); });
};
export var splitGroupNumber = function (value) {
    return (value.match(/.{1,3}/g) || []).join(' ');
};
export var initialWeeks = [
    {
        position: 1,
    },
    {
        position: 2,
    },
    {
        position: 3,
    },
    {
        position: 4,
    },
];
export var useLeaderboard = function (marathonId, currentTeacherId, active) {
    var response = useFetch(active
        ? "/api/v2/" + (currentTeacherId ? 'teachers' : 'supervizors') + "/marathons/" + marathonId + "/leaderboard"
        : undefined, {
        headers: headers,
    }).response;
    var data = response === null || response === void 0 ? void 0 : response.items.map(function (d, index) {
        var leaderBoard = {
            rank: d.rank,
            position: index + 1,
            gradeValue: d.grade.value,
            groupNumber: splitGroupNumber(d.group.number),
            teacherEmail: d.teacher.email,
            teacherId: d.teacher.id,
            totalPoints: d.score,
            weeks: __spreadArray([], initialWeeks, true),
        };
        for (var ind = 0; ind < d.weeklyStats.length; ind++) {
            var week = d.weeklyStats[ind];
            leaderBoard.weeks[ind] = __assign(__assign({}, leaderBoard.weeks[ind]), { points: week.score, students: week.attended, timeSpent: week.minutesSpent, totalStudents: week.rostered, bonus: week.bonus });
        }
        return leaderBoard;
    });
    return { data: data };
};
export var getSchoolYearDates = function () {
    return fetch('/api/v2/calendar/school_year', {
        headers: headers,
    })
        .then(function (res) { return res.json(); })
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .then(function (data) { return ({
        startDate: parseISO(data.beginningOfSchoolYear),
        endDate: parseISO(data.endOfSchoolYear),
    }); });
};
